module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/path-to-regexp/~/isarray/index.js
// module id = 603
// module chunks = 0